import React from 'react';
import CheckBox from '../CheckBox/CheckBox';
import styles from './PreferenceTypeThree.module.scss';

function PreferenceTypeThree({ fields, setLocation, location, disabled }) {
  fields.forEach((item) => {
    item.checked = location[item.option];
  });
  return (
    <form className={`${styles.form} form-check`}>
      {fields?.map((x) => {
        const { checked, id, label, option } = x;
        return (
          <CheckBox
            onChange={(e) => {
              setLocation((y) => ({ ...y, [option]: e.target.checked }));
            }}
            key={id}
            id={`${label}-${id}${disabled}`}
            label={label}
            selected={checked}
            disabled={disabled}
          />
        );
      })}
    </form>
  );
}

export default PreferenceTypeThree;
